import { css } from "styled-components";
import { epicShade100 } from "@theme/colors";
import { type EpicTypographyExtensionProps } from "./fonts.interface";

/**
 * @deprecated This font should not be used
 */
export const FontExtensionCSS = css<EpicTypographyExtensionProps>`
	${({ $bold }) =>
		$bold === false ? "font-weight: 400;" : $bold === true ? "font-weight: 700;" : ""}
	${({ $extraBold }) =>
		$extraBold === false ? "font-weight: 400;" : $extraBold === true ? "font-weight: 900;" : ""}
	${({ $underline }) => ($underline ? "text-decoration: underline;" : "")}
	${({ $strikethrough }) => ($strikethrough ? "text-decoration: line-through;" : "")}
	${({ $italic }) => ($italic ? "font-style: italic;" : "")}
	${({ $color, $inheritColor, theme }) =>
		$color
			? `color: ${$color};`
			: $inheritColor
			? ""
			: `color: ${theme.colors?.fontPrimary ?? epicShade100};`}
	${({ $onClick }) => ($onClick ? "cursor: pointer;" : "")}
`;
